import cx from 'classnames';
import Pattern from "./Pattern.js";
import { PatternOrientation } from "../constants/index.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function pathForOrientation(_ref) {
  let {
    height,
    orientation
  } = _ref;
  switch (orientation) {
    case PatternOrientation.horizontal:
      return `M 0,${height / 2} l ${height},0`;
    case PatternOrientation.diagonal:
      return `M 0,${height} l ${height},${-height} M ${-height / 4},${height / 4} l ${height / 2},${-height / 2}
             M ${3 / 4 * height},${5 / 4 * height} l ${height / 2},${-height / 2}`;
    case PatternOrientation.diagonalRightToLeft:
      return `M 0,0 l ${height},${height}
        M ${-height / 4},${3 / 4 * height} l ${height / 2},${height / 2}
        M ${3 / 4 * height},${-height / 4} l ${height / 2},${height / 2}`;
    case PatternOrientation.vertical:
    default:
      return `M ${height / 2}, 0 l 0, ${height}`;
  }
}
export default function Lines(_ref2) {
  let {
    id,
    width,
    height,
    stroke,
    strokeWidth,
    strokeDasharray,
    strokeLinecap = 'square',
    shapeRendering = 'auto',
    orientation = ['vertical'],
    background,
    className
  } = _ref2;
  const orientations = Array.isArray(orientation) ? orientation : [orientation];
  return /*#__PURE__*/_jsxs(Pattern, {
    id: id,
    width: width,
    height: height,
    children: [!!background && /*#__PURE__*/_jsx("rect", {
      className: cx('visx-pattern-line-background'),
      width: width,
      height: height,
      fill: background
    }), orientations.map((o, i) => /*#__PURE__*/_jsx("path", {
      className: cx('visx-pattern-line', className),
      d: pathForOrientation({
        orientation: o,
        height
      }),
      stroke: stroke,
      strokeWidth: strokeWidth,
      strokeDasharray: strokeDasharray,
      strokeLinecap: strokeLinecap,
      shapeRendering: shapeRendering
    }, `visx-${id}-line-${o}-${i}`))]
  });
}